import { Avatar, Box, Card, CardContent, Divider, Fab, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { Component } from 'react';
import AwardList from './AwardList';
import { Award, AwardEarned, AwardsRequest, Message, User } from './Types/Types';
import { ArrowBack, ArrowForward, Send } from '@mui/icons-material';
import { Virtuoso } from 'react-virtuoso';
interface Props {
    awards: Award[],
    user: User | null,
};
class Awards extends Component<Props, { earned: AwardEarned[], awardId: null | number, messages: Message[] }> {
    messageRef : React.RefObject<HTMLInputElement>;
    constructor(props : Props) {
        super(props);
    
        const awardEarnedStr = localStorage.getItem('awards');
        this.state={
            earned: JSON.parse(awardEarnedStr ?? '[]'),
            awardId: null,
            messages: [],
        };
        this.messageRef = React.createRef();
    }
    

    componentDidMount() {
        this.load();
    }
    
    componentDidUpdate(prevProps : any, prevState : any) {
        if (this.state.awardId !== null) {
            if (prevState.awardId !== this.state.awardId) {
                this.handleGetMessages();
            }
        }
    }
    
    load = () => {
        axios.get<AwardsRequest>('/user/awards')
            .then(res => {
                const awards = res.data;
                localStorage.setItem('awards', JSON.stringify(awards.all));
                localStorage.setItem('awards-earned', JSON.stringify(awards.earned));
                this.setState({
                    // awards: awards.all,
                    earned: awards.earned
                });
            });
    }

    handleUnselectAward = (e : React.MouseEvent) => {
        this.setState({
            awardId: null
        });
    }

    handleSelectAward = (e : React.MouseEvent, award : Award) => {
        this.setState({
            awardId: award.id
        });
    }

    handleGetMessages = () => {
        if (this.state.awardId) {
            axios.get<Message[]>('/awards/messages/' + this.state.awardId)
                .then(res => {
                    this.setState({
                        messages: res.data,
                    }, () => {
                        setTimeout(() => {
                            this.messageRef.current!.scrollTo({ top: this.messageRef.current!.scrollHeight });
                        });
                    });
                });
        }
    }

    handleSendMessage = () => {
        if (this.messageRef && this.messageRef.current) {
            const message = this.messageRef.current.value;
            if (message.length > 0) {
                axios.post<Message[]>('/awards/messages/' + this.state.awardId, {
                    message: message,
                }).then(res => {
                    this.messageRef.current!.value = '';
                    this.setState({
                        messages: res.data,
                    }, () => {
                        setTimeout(() => {
                            this.messageRef.current!.scrollTo({ top: this.messageRef.current!.scrollHeight });
                        });
                    });
                });
            }
        }
    }

    handlePrevAward = (e : React.MouseEvent) => {
        const { awardId } = this.state;
        const { awards } = this.props;

        if (awardId) {
            let index = awards.findIndex(a => a.id === awardId);
            if (--index < 0) {
                index = awards.length - 1;
                if (index < 0) index = 0;
            }
            const newId = awards[index].id;
            this.setState({
                awardId: newId
            });
        }
    }

    handleNextAward = (e : React.MouseEvent) => {
        const { awardId } = this.state;
        const { awards } = this.props;

        if (awardId) {
            let index = awards.findIndex(a => a.id === awardId);
            if (++index >= awards.length) {
                index = 0;
            }
            const newId = awards[index].id;
            this.setState({
                awardId: newId
            });
        }
    }

    render() {
        const { awards, user } = this.props;
        const { earned, awardId, messages } = this.state;
        
        const getAwardCount = () => {
            return (earned.length + ' / ' + awards.length);
        }

        const getAwardAvatar = () => {
            const award = awards.find(a => a.id === awardId);
            let image = award?.image;
            if (image) {
                return getAvatar(image);
            }
            return undefined;
        }

        const getAvatar = (image : null | string) => {
            if (image) {
                if (image.startsWith('hoff')) {
                    return process.env.PUBLIC_URL + '/img/' + image;
                }
                return process.env.PUBLIC_URL + '/awards/' + image;
            }
            return undefined;
        }

        const getName = (award : Award | undefined) => {
            if (award?.is_secret) {
                return award?.name.split('').map((char, index) => {
                    return '?';
                }).join('');
            }
            return award?.name;
        }

        const getDescription = (award : Award | undefined) => {
            if (award?.is_secret) {
                return award.name.split('').map((char, index) => {
                    return '?';
                }).join('');
            }
            return award?.description;
        }

        const isEarned = (award : Award | undefined) => {
            return earned.find(e => e.award_id === award?.id);
        }

        const award = awards.find(a => a.id === awardId);

        return (
            <React.Fragment>
                {awardId 
                ? <React.Fragment>
                    <Box sx={{ display: 'flex', p: 2 }}>
                        <Box sx={{ width: '20px' }}>
                            <IconButton onClick={this.handleUnselectAward}>
                                <ArrowBack />
                            </IconButton>
                        </Box>
                        <Box flexGrow={1}></Box>
                        <Box sx={{ display: 'grid', placeItems: 'center', position: 'relative' }}>
                            <Box sx={{ position: 'absolute', left: 15 }}>
                                <Fab
                                    size="small"
                                    onClick={(e) => this.handlePrevAward(e)}
                                    disabled={false}
                                    sx={{ borderRadius: '0.5em' }}
                                >
                                    <ArrowBack />
                                </Fab>
                            </Box>
                            <Box>
                                <Card sx={{ display: 'grid', placeItems: 'center', width: {xs: '250px', sm: '275px'}, height: {xs: '220px', sm: '200px'}, overflow: 'hidden', backgroundColor: '#313131', border: '1px solid rgba(255, 215, 0, 0.18)' }}>
                                    <CardContent sx={{ display: 'grid', placeItems: 'center' }}>
                                        <Avatar alt={"Profil"} src={getAwardAvatar()} sx={{ height: 128, width: 128, filter: isEarned(award) ? undefined : 'blur(5px)' }} />
                                        <Typography textAlign={'center'} variant={'h5'} sx={{ p: 2, paddingBottom: 0 }}>{getName(award)}</Typography>
                                    </CardContent>
                                </Card>
                            </Box>
                            <Box sx={{ position: 'absolute', right: 15 }}>
                                <Fab
                                    size="small"
                                    onClick={(e) => this.handleNextAward(e)}
                                    disabled={false}
                                    sx={{ borderRadius: '0.5em' }}
                                >
                                    <ArrowForward />
                                </Fab>
                            </Box>
                        </Box>
                        <Box flexGrow={1}></Box>
                        <Box sx={{ width: '20px' }}></Box>
                    </Box>
                    <Box>
                        <Typography textAlign={'center'} variant={'body1'} sx={{ paddingBottom: 0 }}>{getDescription(award)}</Typography>
                    </Box>
                    <Box>
                        <Typography textAlign={'center'} variant={'h5'} sx={{ p: 2, pb: 0 }}>Nochrichtn</Typography>
                        <Typography textAlign={'center'} variant={'body1'} sx={{ pb: 2 }}>Sog deine Buam wia dos geht.</Typography>
                    </Box>
                    <Divider />
                    <Box flexGrow={1} sx={{ marginTop: 2, overflowY: 'auto', paddingRight: 1, minHeight: '200px' }}>
                        {messages.length > 0
                            ? <Virtuoso data={messages} itemContent={(index : number, message : Message) => {
                                const isMe = message.user_id === user?.id;
                                const sameUser = index > 0 && message.user_id === messages[index-1].user_id;

                                return <Box key={'msg-'+message.id} sx={{ display: 'flex', width: '100%', justifyContent: isMe ? 'flex-end' : 'flex-start' }}>
                                    <Box flexGrow={0} sx={{ marginBottom: 1, flexBasis: '80%' }}>
                                        <Box sx={{ display: 'flex', flexDirection: isMe ? 'row-reverse' : 'row' }}>
                                            <Box sx={{ minWidth: '40px' }}>
                                                {sameUser === false && <Avatar src={getAvatar(message.user_image)}/>}
                                            </Box>
                                            <Card sx={{ marginLeft: 2, marginRight: 2, background: isMe ? '#313131' : '#232323', border: '1px solid rgba(255, 215, 0, 0.1)' }}>
                                                <CardContent sx={{ padding: '4px !important', paddingLeft: '8px !important', paddingRight: '8px !important', lineHeight: '1.25em' }}>
                                                    <Box>
                                                        {sameUser === false && <Box sx={{ fontWeight: 'bold', fontSize: '0.65em', textAlign: isMe ? 'right' : 'left' }}>{message.user_name}</Box>}
                                                        <Box>{message.text}</Box>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Box>
                                    </Box>
                                </Box>;    
                            }}/>
                            : <Box sx={{ display: 'grid', placeItems: 'center', height: '100%', width: '100%', textAlign: 'center' }}>
                                <Box>
                                    <Box>No nix do!</Box>
                                    <Box>Amend dafrogst spada wos.</Box>
                                </Box>
                            </Box>}
                    </Box>
                    <Box sx={{ padding: '4px' }}>
                        <form onSubmit={(e) => this.handleSendMessage()}>
                            <TextField 
                                inputRef={this.messageRef}
                                fullWidth 
                                multiline
                                placeholder='Dazöh wia kriag i de Ehrung?'
                                onSubmit={(e) => this.handleSendMessage()}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={(e) => this.handleSendMessage()}>
                                                <Send />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}/>
                        </form>
                    </Box>
                </React.Fragment>
                : <React.Fragment>
                    <Box textAlign={'center'}>
                        <Typography textAlign={'center'} variant={'h4'} sx={{ p: 2, paddingBottom: 0 }}>Ehrunga: {getAwardCount()}</Typography>
                        <Typography textAlign={'center'} variant={'body2'} sx={{ p: 2, paddingTop: 0 }}>Fleißiga Sauteufe!</Typography>
                    </Box>
                    <Divider />
                    <Box flexGrow={1} sx={{ minHeight: '200px' }}>
                        <AwardList awards={awards} earned={earned} onClick={this.handleSelectAward}/>
                    </Box>
                </React.Fragment>}
            </React.Fragment>
        );
    }
}
export default Awards;